// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/apply_generation_grading.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GradingSettings } from "../../grading/v1/grading_settings_pb";
import { file_vision_grading_v1_grading_settings } from "../../grading/v1/grading_settings_pb";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/apply_generation_grading.proto.
 */
export const file_vision_generations_v1_apply_generation_grading: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vZ2VuZXJhdGlvbnMvdjEvYXBwbHlfZ2VuZXJhdGlvbl9ncmFkaW5nLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIvMBCh1BcHBseUdlbmVyYXRpb25HcmFkaW5nUmVxdWVzdBJSCgZwYXJhbXMYASABKAsyQi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkFwcGx5R2VuZXJhdGlvbkdyYWRpbmdSZXF1ZXN0LlBhcmFtcxp+CgZQYXJhbXMSFQoNZ2VuZXJhdGlvbl9pZBgBIAEoCRJDChBncmFkaW5nX3NldHRpbmdzGAIgASgLMikucHJvdG9zLnZpc2lvbi5ncmFkaW5nLnYxLkdyYWRpbmdTZXR0aW5ncxIYChBncmFkZWRfdXBsb2FkX2lkGAMgASgJIsMBCh5BcHBseUdlbmVyYXRpb25HcmFkaW5nUmVzcG9uc2USUwoGcmVzdWx0GAEgASgLMkMucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5BcHBseUdlbmVyYXRpb25HcmFkaW5nUmVzcG9uc2UuUmVzdWx0GkwKBlJlc3VsdBJCCgpnZW5lcmF0aW9uGAEgASgLMi4ucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5WaXNpb25HZW5lcmF0aW9uYgZwcm90bzM", [file_vision_grading_v1_grading_settings, file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.ApplyGenerationGradingRequest
 */
export type ApplyGenerationGradingRequest = Message<"protos.vision.generations.v1.ApplyGenerationGradingRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ApplyGenerationGradingRequest.Params params = 1;
   */
  params?: ApplyGenerationGradingRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ApplyGenerationGradingRequest.
 * Use `create(ApplyGenerationGradingRequestSchema)` to create a new message.
 */
export const ApplyGenerationGradingRequestSchema: GenMessage<ApplyGenerationGradingRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_apply_generation_grading, 0);

/**
 * @generated from message protos.vision.generations.v1.ApplyGenerationGradingRequest.Params
 */
export type ApplyGenerationGradingRequest_Params = Message<"protos.vision.generations.v1.ApplyGenerationGradingRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.grading.v1.GradingSettings grading_settings = 2;
   */
  gradingSettings?: GradingSettings | undefined;

  /**
   * @generated from field: string graded_upload_id = 3;
   */
  gradedUploadId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ApplyGenerationGradingRequest.Params.
 * Use `create(ApplyGenerationGradingRequest_ParamsSchema)` to create a new message.
 */
export const ApplyGenerationGradingRequest_ParamsSchema: GenMessage<ApplyGenerationGradingRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_apply_generation_grading, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ApplyGenerationGradingResponse
 */
export type ApplyGenerationGradingResponse = Message<"protos.vision.generations.v1.ApplyGenerationGradingResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ApplyGenerationGradingResponse.Result result = 1;
   */
  result?: ApplyGenerationGradingResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ApplyGenerationGradingResponse.
 * Use `create(ApplyGenerationGradingResponseSchema)` to create a new message.
 */
export const ApplyGenerationGradingResponseSchema: GenMessage<ApplyGenerationGradingResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_apply_generation_grading, 1);

/**
 * @generated from message protos.vision.generations.v1.ApplyGenerationGradingResponse.Result
 */
export type ApplyGenerationGradingResponse_Result = Message<"protos.vision.generations.v1.ApplyGenerationGradingResponse.Result"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ApplyGenerationGradingResponse.Result.
 * Use `create(ApplyGenerationGradingResponse_ResultSchema)` to create a new message.
 */
export const ApplyGenerationGradingResponse_ResultSchema: GenMessage<ApplyGenerationGradingResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_apply_generation_grading, 1, 0);

